export const en = {
  "BACK_BUTTON": "Back",
  "NEXT_BUTTON": "Next",
  "I_AGREE": "I agree",
  "FINISH_BUTTON": "Finish",
  "CHOICES_TITLE": "Choices",
  "SELECT_INPUT": "Input Name",
  "MULTICHOICE_PEER_PLACEHOLDER": "Select person(s)",
  "MULTICHOICE_PEER_REQUIRED_ERROR": "Select at least one person.",
  "MULTICHOICE_OTHER_LABEL": "Other (please specify)",
  "MULTICHOICE_OTHER_PLACEHOLDER": "Please specify",
  "MULTICHOICE_OTHER_TEXT_REQUIRED": "Please specify your answer for \"Other\".",
  "MULTICHOICE_OTHER_TEXT_TOO_LONG": "Your answer must be 1000 characters or fewer.",
  "MULTICHOICE_CLEAR_SELECTION": "Clear selection",
  "LIKERT_HINT": "Select a person and assign a score.",
  "LIKERT_SCORE_LABEL": "Score",
  "LIKERT_INCOMPLETE_ERROR": "Select both person and score for each row.",
  "LIKERT_INVALID_ERROR": "One or more scores are outside the allowed range.",
  "EMPTY_ERROR": "Required field",
    "SUBMIT_ERROR": "Failed to submit answers. Please review your responses.",
  "SENDING_DATA": "Sending data...",
  "LOADING": "Loading...",
  "MAX_SELECT_ERROR": "Max selected is:",
  "FORM_ALREADY_ANSWERED": "Thank you for answering!",
  "THANK_YOU": "Thank you for your participation in the Organizational Network Analysis (ONA) survey. Your feedback has been submitted.",
  "MAX_SELECT_CUSTOM_MESSAGE": "You have reached the max option's value",
  "SKILL_PLACEHOLDER": "Skill level",
  "QR_SELECT_TITLE": "Select your name",
  "QR_SELECT_PLACEHOLDER": "Search for your name...",
  "QR_NO_PARTICIPANTS": "No participants available. All participants have already responded.",
  "QR_SURVEY_NOT_FOUND": "Survey not found",
  "QR_LOAD_ERROR": "Unable to load participants. Please try again.",
  "QR_PARTICIPANT_ALREADY_ANSWERED": "This participant has already completed the survey. Please go back and select your name again.",
  "QR_BACK_TO_SELECTION": "Back to name selection",
  "companyValues": {
    "PASSION": "Passion for everything we do",
    "INNOVATING": "Always innovating",
    "CONFIDENCE": "With confidence and responsibility",
    "WINNING": "Winning as a team",
    "DIFFERENCE": "Committed to make a difference"
  }
}